import { render, staticRenderFns } from "./duplicate-invoice.vue?vue&type=template&id=2ad38c72"
import script from "./duplicate-invoice.vue?vue&type=script&lang=js"
export * from "./duplicate-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports